import React from 'react';
import TenantSettings from './TenantSettings';

const index = () => <TenantSettings />;

export default index;
